import { EditorState } from '../../slices/editor';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';

export const selectImageProperties = (): any =>
    createSelector(
        (state: RootState) => state.editor,
        (state: EditorState) => state.instanceTemplate?.values?.filter((item) => item.path === 'content.src'),
    );
